<template>
  <div class="center">
    <h1 class="centered">{{ $t("form.welcome_title") }}</h1>
    <p class="p-centered">{{ $t("form.welcome_text") }}</p>
    <p class="centered">{{ $t("form.choose_language") }}</p>
    <locale-changer class="centered"></locale-changer>
    <p class="centered">{{ $t("form.start") }}</p>
    <!--Iniziamo!-->
    <div class="centered">
      <Button
        class="p-button-lg p-button-rounded"
        icon="pi pi-chevron-right"
        @click="$router.push('term-and-condition')"
      ></Button>
    </div>
  </div>
</template>

<script>
import LocaleChanger from "../components/LocaleChanger.vue";
export default {
  components: { LocaleChanger },
  mounted() {},
};
</script>

<style scoped>
h1 {
  font-family: raleway, sans-serif;
  font-weight: 700;
  font-style: normal;
  color: black;
  font-size: 52px;
}

p {
  font-family: raleway, sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 16px;
  color: black;
}

.centered {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.p-centered {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  text-align: center;
}

.center {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>
